import React from 'react'

const NoFoundPage = () => {
  return (
    <div>Página no encontrada</div>
  )
}

export default NoFoundPage